// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider";
import { SiteProvider } from "./context/site";

import Loader from './components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<AuthProvider>
			<SiteProvider>
				<div>
					<App />
					<div className="loader_bg">
						<div className="loader">
							<img src="img/loading.gif" alt="#"/>
						</div>
					</div>
					
				</div>
			</SiteProvider>
		</AuthProvider>
	</React.StrictMode>
);


reportWebVitals();